module.exports = __webpack_public_path__ + "static/img/stoerer_reisen.6079db3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stoerer_reisen.png
// module id = IO7+
// module chunks = 2